'use client';

import { useEffect, useRef } from 'react';
import type { LayoutFitVerdict, SystemLayout } from '@/lib/gear/layoutFit';
import { EVENTS, track } from '@/lib/analytics';

interface Props {
  receiverId: string;
  layout: SystemLayout;
  verdict: LayoutFitVerdict;
}

/** Fires `gear_layout_viewed` once per page view. Renders nothing. */
export default function GearLayoutViewed({ receiverId, layout, verdict }: Props) {
  // Guards React's development double-invoke; a client-side navigation to
  // another receiver or layout changes the key and counts as a new view.
  const sent = useRef<string | null>(null);
  useEffect(() => {
    const key = `${receiverId}|${layout}`;
    if (sent.current === key) return;
    sent.current = key;
    track(EVENTS.gear_layout_viewed, { receiver_id: receiverId, layout, verdict });
  }, [receiverId, layout, verdict]);
  return null;
}
